var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.73116624%",
    y1: "93.4850191%",
    x2: "93.5910491%",
    y2: "6.61873642%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF543E",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C837AB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share-outside-Sekeron---Done",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sharing-any-post-outside-sekeron-171",
    transform: "translate(-716, -580)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(676, 380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(0, 30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-54",
    transform: "translate(0, 74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(0, 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(40, 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.08694058,2.22166321 C-0.420009182,4.82564761 0.0930780961,7.59179949 0.0930780961,15.9952652 C0.0930780961,22.9737839 -1.12450726,29.9695827 5.24787723,31.6165131 C7.23775198,32.1282712 24.8688133,32.1282712 26.8560295,31.6138547 C29.5091959,30.9292952 31.6678843,28.777253 31.962976,25.0248038 C32.0041825,24.5010826 32.0041825,7.49875258 31.9616467,6.96439743 C31.6479457,2.96736778 29.1875194,0.663791992 25.945499,0.197228172 C25.2024529,0.089559598 25.0535779,0.0576577984 21.2413128,0.0510115901 C7.71893746,0.0576577984 4.75472858,-0.544488671 2.08694058,2.22166321 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0413195,4.22350114 C11.214843,4.22350114 6.63161779,3.79415609 4.88100653,8.28699288 C4.15789907,10.1426142 4.26290916,12.5525293 4.26290916,16.0032407 C4.26290916,19.0312532 4.16587452,21.8771595 4.88100653,23.7181592 C6.62763007,28.2136545 11.2480741,27.7829802 16.038661,27.7829802 C20.6604342,27.7829802 25.4257655,28.2641657 27.1976447,23.7181592 C27.9220814,21.8439285 27.815742,19.4699029 27.815742,16.0032407 C27.815742,11.4014061 28.0696272,8.43055097 25.8378304,6.20008348 C23.5781196,3.94037267 20.5221931,4.22350114 16.0360025,4.22350114 L16.0413195,4.22350114 Z M14.9859016,6.34630006 C25.0535779,6.33034916 26.3349668,5.21112769 25.6278103,20.7592673 C25.3765836,26.25834 21.1894724,25.6548643 16.0426487,25.6548643 C6.65820262,25.6548643 6.38836657,25.3863575 6.38836657,15.9979237 C6.38836657,6.50049209 7.13274189,6.35161703 14.9859016,6.34364158 L14.9859016,6.34630006 Z M22.3286325,8.30161453 C21.5483676,8.30161453 20.9156486,8.93433356 20.9156486,9.71459841 C20.9156486,10.4948633 21.5483676,11.1275823 22.3286325,11.1275823 C23.1088973,11.1275823 23.7416164,10.4948633 23.7416164,9.71459841 C23.7416164,8.93433356 23.1088973,8.30161453 22.3286325,8.30161453 L22.3286325,8.30161453 Z M16.0413195,9.95386191 C12.7009352,9.95386191 9.99326993,12.6628564 9.99326993,16.0032407 C9.99326993,19.3436249 12.7009352,22.0512902 16.0413195,22.0512902 C19.3817037,22.0512902 22.0880397,19.3436249 22.0880397,16.0032407 C22.0880397,12.6628564 19.3817037,9.95386191 16.0413195,9.95386191 Z M16.0413195,12.0766608 C21.2320081,12.0766608 21.2386543,19.9298205 16.0413195,19.9298205 C10.85196,19.9298205 10.8439846,12.0766608 16.0413195,12.0766608 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstagram);
export default __webpack_public_path__ + "static/media/ic_instagram.6e47019311a52bf8f1f43a34febcb670.svg";
export { ForwardRef as ReactComponent };